import { inject, NgModule } from '@angular/core';
import { NgbAlert, NgbAlertConfig } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
    imports: [NgbAlert],
    exports: [NgbAlert],
})
export class AlertModule {
    private readonly config = inject(NgbAlertConfig);
    constructor() {
        this.config.type = 'success';
        this.config.dismissible = false;
    }
}
